export default __webpack_public_path__ + "static/media/colors-100.f8cd3a7f.png";